/**
 * The short address printed on, or shared as, anything with a code on it.
 *
 * One place so the six things that build these links cannot drift apart, and so
 * moving the domain again is one edit rather than a hunt.
 *
 * `scan.hadv.quest` rather than the player's own origin because these end up in
 * the physical world — on a geocache, a poster, a card — and a shorter address
 * is a smaller, more forgiving QR code. It also means a phone with the app
 * installed opens the app instead of a browser, since that host is the one the
 * app claims.
 */

export const SHARE_HOST = 'scan.hadv.quest'

/**
 * The link for a share code: an adventure, a group invite, a profile.
 *
 * Codes are shared with their display prefix intact (`U…` for a user referral);
 * the server strips it when matching, so it travels as written.
 */
export function buildShareCodeUrl(shareCode: string): string {
  return `https://${SHARE_HOST}/${encodeURIComponent(shareCode)}`
}
